/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";

import state from "./state"
import getters from "./getters"
import mutations from "./mutations"
import actions from "./actions"

import Auth from "./modules/Auth.store"
import Event from "./modules/Event.store"
import Utility from "./modules/Utility.store"
import Order from "./modules/Order.store"

Vue.use(Vuex)

const modules = {
  Auth: Auth,
  Utility: Utility,
  Order: Order,
  Event: Event
}


export default new Vuex.Store({
  getters,
  mutations,
  state,
  actions,
  modules,
  plugins: [createPersistedState({
    key: 'soldoutt-nimda'
  })],
  strict: process.env.NODE_ENV !== 'production'
})
